// extracted by mini-css-extract-plugin
export default {"header":"gameHeader_header__fbx1s","icon":"gameHeader_icon__rKNKt","inner":"gameHeader_inner__LRTbs","link":"gameHeader_link__z0Izw"};